module.exports = __webpack_public_path__ + "media/images/31-circle-plus-blue-1aaa36cf9bc281dfef5598a09655cf5c.png";